const THREE = require('three')  
import IntroSpritesheet from '@/assets/sprites/intro' 
import MovieClip from 'src/helpers/MovieClip' 
 
class SpaceFace extends THREE.Group {

  constructor(config) {

    super();

    this.position.z = -900;
    this.position.y = -100;//(window.innerHeight * 0.15); 
  
    this.setup();
    this.resize() 
  } 

  setup() { 
 
     const data = [
      {
        w: 1024, h: 1024, x: 0, y: 0,z: -350,  s: 0.57,  frame: 17 
      },
      { 
        w: 128, h: 256, x: -120, y: -55,z:-10,  s: 0.4, frame: 18 
      },
      {
        w: 256, h: 256, x: -20, y: 155,z:13,  s: 0.4, frame: 19 
      },
      {
        w: 256, h: 128, x: 175, y: 128,z:-150,  s: 0.5, frame: 20 
      },
      {
        w: 128, h: 128, x: -25, y: -35,z:0,  s: 0.4, frame: 21 
      },
      {
        w: 128, h: 128, x: 130, y: 80,z: 70,  s: 0.36, frame: 22 
      },
      {
        w: 64, h: 32, x: 160, y: 140,z:1,  s: 0.4, frame: 23 
      },
      {
        w: 512, h: 512, x: 90, y: 20,z:150,  s: 0.38, frame: 24 
      },
      {
        w: 64, h: 128, x: -75, y: 175,z: -102,  s: 0.45, frame: 25 
      },
      {
        w: 128 , h: 64, x: -150, y: 140,z: -200,  s: 0.5, frame: 26 
      },
      {
        w: 128 , h: 128, x: -120, y: 80,z: 7.5,  s: 0.4, frame: 27 
      },
      {
        w: 128 , h: 256, x: -120, y: 30,z:100,  s: 0.37, frame: 28 
      },
      {
        w: 32 , h: 128, x: -150, y: -30,z:0.3,  s: 0.4, frame: 29 
      },
      {
        w: 128 , h: 64, x: -185, y: -120,z:-300,  s: 0.6, frame: 30 
      },
      {
        w: 128 , h: 256, x: 90, y: -82,z:240,  s: 0.3,frame: 31 
      },
      {
        w: 128 , h: 128, x: 85, y: -122,z:370,  s: 0.25, frame: 32 
      },
      {
        w: 64 , h: 64, x: 70, y: -145,z:4,  s: 0.4, frame: 33 
      },
      {
        w: 256 , h: 256, x: 20, y: -80, z:400,  s: 0.2, frame: 34 
      },
      {
        w: 128, h: 256, x: 70, y: -65, z:150,  s: 0.31, frame: 35 
      },
      {
        w: 128, h: 128, x: 34, y: -90, z:130,  s: 0.3, frame: 36 
      },
      {
        w: 64, h: 64, x: 45, y: -53,z: 210,  s: 0.36,frame: 37 
      },
      {
        w: 128, h: 256, x: 24, y: -95,z:0.98,  s: 0.4, frame: 38 
      },
      {
        w: 256, h: 128, x: -5, y: -120,z:105,  s: 0.32, frame: 39 
      },
      {
        w: 256, h: 256, x: -45, y: -140, z:-390,  s: 0.55, frame: 40 
      },
      {
        w: 64, h: 64, x: 10, y: -50,z:7, s: 0.4, frame: 41 
      },
      {
        w: 128, h: 128, x: 30, y: -37,z:110,  s: 0.37, frame: 42
      },
      {
        w: 256, h: 256, x: -60, y: 77,z:-149,  s: 0.53, frame: 43
      }
    ] 
 

    let texture = this.createTexture(require('@/assets/sprites/intro.png'));
    for (var i = 0; i < data.length; i++) { 
      
      let mc =new MovieClip({
        fps: 5,
        frames: IntroSpritesheet.frames,
        frame_width: data[i].w,
        frame_height: data[i].h, 
        spritesheet_width: IntroSpritesheet.meta.size.w,
        spritesheet_height: IntroSpritesheet.meta.size.h, 
        texture: texture
      });  

      mc.position.x = data[i].x;  
      mc.position.y = data[i].y;  
      mc.position.z = data[i].z;  
      mc.scale.y = mc.scale.x = data[i].s;
      mc.gotoAndStop(data[i].frame) 
      this.add(mc);
    }
  }

  createTexture(url){
    let img = ImageService.get(url) 
    let texture = new THREE.Texture(img);   
    texture.needsUpdate = true;
    return texture;
  }

  resize() {
      
  }
 
 
}

export default SpaceFace